import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

export const HomeThread = props => (
  <div className="columns column-block">
    <Link
      to={props.link}
      className={`home-thread ${props.className}`}
      style={{ backgroundImage: `url(${props.img})` }}
    >
      <div className="home-thread__category">
        <span>{props.category}</span>
        {/* <span role="img" aria-label="lit">
          {props.streak}
        </span>
  <span> {props.streakCount}</span> */}
      </div>

      <div className="home-thread__description-wrap">
        <p className="home-thread__description">{props.name}</p>
      </div>
      <div className="home-thread__overlay" />
    </Link>
  </div>
);

HomeThread.propTypes = {
  category: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  img: PropTypes.any,
  link: PropTypes.string,
  streak: PropTypes.string,
  streakCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

HomeThread.defaultProps = {
  className: '',
  link: '/'
};
